module.exports = __webpack_public_path__ + "static/media/errorimage.2dd21570.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/errorimage.png
// module id = 706
// module chunks = 42